import { useRef, useState } from "react";
import PublicPage from "./PublicPage.jsx";
import Turnstile from "./Turnstile.jsx";
import { api } from "./api.js";
import { SUPPORT_EMAIL } from "./legalInfo.js";

export default function ContactPage({ onNavigate, onGetStarted }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(""); // '', 'sending', 'sent'
  const [error, setError] = useState("");
  const [turnstileToken, setTurnstileToken] = useState(null);
  const turnstileRef = useRef(null);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setStatus("sending");
    try {
      await api.sendContactMessage(name, email, message, turnstileToken);
      setStatus("sent");
    } catch (err) {
      setError(err.message);
      setStatus("");
      turnstileRef.current?.reset();
      setTurnstileToken(null);
    }
  }

  return (
    <PublicPage title="Contact" onNavigate={onNavigate} onGetStarted={onGetStarted}>
      <p className="legal-p">
        Email us directly at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>,
        or use the form below.
      </p>

      {status === "sent" ? (
        <div className="card">
          <p>Thanks — your message is on its way. We'll reply by email.</p>
        </div>
      ) : (
        <form className="card contact-form" onSubmit={submit}>
          {error && <div className="error">{error}</div>}
          <label className="field">
            <span>Name</span>
            <input value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="field">
            <span>Message</span>
            <textarea
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </label>
          <Turnstile ref={turnstileRef} action="contact_form" onToken={setTurnstileToken} />
          <button className="primary block" disabled={status === "sending" || !turnstileToken}>
            {status === "sending" ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </PublicPage>
  );
}
